import $ from 'jquery';
window.$ = window.jQuery = $;
import 'jquery.maskedinput';
import 'jquery-ui/ui/widgets/tooltip';
import 'tablesorter';
// import NiceSelect from "nice-select2/dist/js/nice-select2.js";
import "nice-select2/dist/css/nice-select2.css";
import 'select2';
import Cleave from 'cleave.js';
import 'cleave.js/dist/addons/cleave-phone.us';
import "axios";
import "rangeslider.js";
import { v4 as uuidv4 } from 'uuid';
import 'dirrty';
import 'bootstrap';
import { Tooltip, Toast, Popover } from 'bootstrap';
import { createPopper } from '@popperjs/core';
import Popper from 'popper.js';
import './stripe';
import './admin';
import moment from 'moment';
import 'daterangepicker';
import { emailNotificationsScriptModule } from "./emailNotificationsScript";
import { adminModule } from "./admin";
import { analyticsModule } from "./analytics";
import { contractorsModule } from "./contractors";
import { accountModule } from "./account";
import { propertiesModule } from "./properties";
import { brokerPocModule } from './broker/poc';
import { brokerBrokersModule } from './broker/brokers';
import { brokerVouchersModule } from './broker/vouchers';
import { brokerSubscriptionModule } from './broker/subscription';


import "./emailNotificationsScript";
import './coireq';
import './phoneNumbers';
import './faq';
import './header';
import './account';
import './breadcrumbs';
import './subscriptions';
import './gijgo-datepicker';
import './support';
import './accountFormsVerify';
import './contractors';
import './properties';
import './broker/poc';
import './broker/brokers';
import './analytics';
import './broker/subscription';
import './broker/vouchers';

window.Popper = Popper;
// make webpacked modules available globally
window.emailNotificationsScriptModule = emailNotificationsScriptModule;
window.adminModule = adminModule;
window.analyticsModule = analyticsModule;
window.contractorsModule = contractorsModule;
window.accountModule = accountModule;
window.propertiesModule = propertiesModule;
window.brokerPocModule = brokerPocModule;
window.brokerBrokersModule = brokerBrokersModule;
window.brokerVouchersModule = brokerVouchersModule;
window.brokerSubscriptionModule = brokerSubscriptionModule;

window.moment = moment;
window.uuidv4 = uuidv4;

// validate jquery 
const jQueryVersion = $.fn.jquery;
const jQueryScript = document.querySelector('script[src*="jquery"]');
const jQuerySource = jQueryScript ? jQueryScript.src : 'jQuery source not found';
console.log(`jQuery Loaded: Version ${jQueryVersion}, Source ${jQuerySource}`);

document.addEventListener('DOMContentLoaded', function() {
    var inputs = document.querySelectorAll('.input-phone');
    if (inputs.length > 0) {
        inputs.forEach(function(input){
            new Cleave(input, {
                phone: true,
                delimiter: '-',
                phoneRegionCode: 'US',
            });
        });

    }
    styleBreadCrumbs();
    window.emailNotificationsScriptModule.displayCheckedBoxes();
    $(function () {
        $('[data-toggle="tooltip"]').tooltip({html:true});
    })
});

function user_agreement () {
    console.log("opening user-agreement modal");
    $('#user-agreement').modal('show');
}
window.user_agreement = user_agreement
